var map = {
	"./Dashboard_and_statistics.svg": "kNUO",
	"./Manage_solutions.svg": "psO3",
	"./New_registration.svg": "9XGT",
	"./SME.svg": "ocYT",
	"./SME_logo.svg": "YuUM",
	"./Solution_certification.svg": "wjcC",
	"./address_logo.svg": "GWq8",
	"./arrowDown.svg": "WYMj",
	"./arrowDownDarkBlue.svg": "UFhN",
	"./calendar.svg": "BZso",
	"./contact_us.svg": "fluA",
	"./contact_us_logo.svg": "ID2w",
	"./continue.svg": "N+6s",
	"./dashboard_logo.svg": "zU4P",
	"./delete.svg": "mMQ0",
	"./done.svg": "rQzq",
	"./download.svg": "Z3LA",
	"./downloadInvoice.svg": "V1Cd",
	"./edit.svg": "XRFS",
	"./email_logo.svg": "2RhJ",
	"./grayCircle.svg": "3sbd",
	"./grayLine.svg": "Zp0C",
	"./greenBorderCircle.svg": "IvrB",
	"./greenLine.svg": "X7yY",
	"./green_check.svg": "sAas",
	"./info.svg": "bf//",
	"./left-arrow.svg": "4Q4Z",
	"./leftArrow.svg": "TBdu",
	"./location.svg": "Ii6O",
	"./logo.svg": "X7t1",
	"./logout.svg": "kiTj",
	"./logoutDarkBlue.svg": "D5PC",
	"./logout_logo.svg": "jOAu",
	"./logout_logo_sidebar.svg": "R9xF",
	"./mail.svg": "cuiR",
	"./manage_solutions_logo.svg": "IhOZ",
	"./new_reg_logo.svg": "n6c0",
	"./notSubmitted.svg": "FUql",
	"./rejectedInvoice.svg": "5rtI",
	"./resetForm.svg": "UzRi",
	"./right-arrow.svg": "reng",
	"./saveForm.svg": "NyJ5",
	"./searchIcon.svg": "iUwR",
	"./serviceProvider.svg": "y47e",
	"./simplified.svg": "6fCx",
	"./solutionReg.svg": "hjYR",
	"./solution_logo.svg": "LlQq",
	"./solution_reg_logo.svg": "s9KV",
	"./standard.svg": "mVQd",
	"./tax_return.svg": "3WU1",
	"./view.svg": "jEtX",
	"./viewInvoice.svg": "gn/k",
	"./viewInvoices.svg": "Iebk"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ogvf";